module.exports = __webpack_public_path__ + "img/iphone-4.cda6deb2.jpeg";